<template>
    <VueFinalModal class="vfm-modal"
      content-class="vfm-modal-content"
      content-transition="vfm-fade"
      overlay-transition="vfm-fade">
      <h1 class="text-xl">
        {{ title }}
      </h1>
      <slot />
      <div class="footer">
        <!--
        <Button :full-width="false" variant="secondary" @click="emit('cancel')">
            Annuler
        </Button>
        -->
        <Button :full-width="false" @click="emit('confirm')">
            Valider
        </Button>
      </div>
    </VueFinalModal>
</template>

<script setup lang="ts">
    import Button from '@/components/atoms/Button.vue'
    import { VueFinalModal } from 'vue-final-modal'
    defineProps<{
        title?: string
    }>()
    const emit = defineEmits<{
        (e: 'confirm'): void,
        (e: 'cancel'): void
    }>()

</script>